import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Switch } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import ErrorBoundary from 'ErrorBoundary'
import { RequireAuthRoute, RequireUnauthRoute } from 'components'

import LoginPage from 'scenes/Login'
import RegisterPage from 'scenes/Register'
import ForgotPassword from 'scenes/ForgotPassword'
import ResetPassword from 'scenes/ResetPassword'
import ArticlePage from 'scenes/Article'

const App = props => {
	const { authenticated, email, favicon } = props

	return (
		<ErrorBoundary email={email}>
			{favicon ? (
				<Helmet>
					<link
						rel="shortcut icon"
						href={`${process.env.STORAGE}/${favicon}`}
					/>
				</Helmet>
			) : (
				<Helmet>
					<meta name="application-name" content="Skara" />
					<meta name="theme-color" content="#ffffff" />
					<meta name="msapplication-TileColor" content="#a68eff" />
					<meta
						name="msapplication-config"
						content="/assets/img/favicons/browserconfig.xml"
					/>
					<link
						rel="shortcut icon"
						href="/assets/img/favicons/favicon.ico"
					/>
					<link
						rel="apple-touch-icon"
						sizes="180x180"
						href="/assets/img/favicons/apple-touch-icon.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="32x32"
						href="/assets/img/favicons/favicon-32x32.png"
					/>
					<link
						rel="icon"
						type="image/png"
						sizes="16x16"
						href="/assets/img/favicons/favicon-16x16.png"
					/>
					<link
						rel="manifest"
						href="/assets/img/favicons/site.webmanifest"
						crossOrigin="use-credentials"
					/>
					<link
						rel="mask-icon"
						href="/assets/img/favicons/safari-pinned-tab.svg"
						color="#5bbad5"
					/>
				</Helmet>
			)}
			<Switch>
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/login"
					component={LoginPage}
				/>
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/verify-email"
					component={() => (
						<div className="u-center-inside-flex u-max-width--small">
							Verifying account …
						</div>
					)}
				/>
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/verify-email/failed"
					component={() => (
						<div className="u-center-inside-flex u-max-width--small">
							Verifying account failed …
						</div>
					)}
				/>
				{/* <RequireUnauthRoute
					authenticated={authenticated}
					path="/login/:workspace"
					component={LoginPage}
				/> */}
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/register"
					component={RegisterPage}
				/>
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/forgot-password"
					component={ForgotPassword}
				/>
				<RequireUnauthRoute
					authenticated={authenticated}
					exact
					path="/reset-password"
					component={ResetPassword}
				/>
				{/* <RequireUnauthRoute
					authenticated={authenticated}
					path="/register/:workspace"
					component={RegisterPage}
				/> */}
				<RequireAuthRoute
					authenticated={authenticated}
					exact
					path="/"
					component={ArticlePage}
				/>
				<RequireAuthRoute
					authenticated={authenticated}
					exact
					path="/:workspace"
					component={ArticlePage}
				/>
				<RequireAuthRoute
					authenticated={authenticated}
					exact
					path="/:workspace/:id"
					component={ArticlePage}
				/>
			</Switch>
		</ErrorBoundary>
	)
}

App.propTypes = {
	authenticated: PropTypes.bool.isRequired,
	email: PropTypes.string,
}

App.defaultProps = {
	email: null,
}

const mapStateToProps = state => ({
	authenticated: !!state.auth.token,
	email: state.auth.email,
	favicon: state.auth.team ? state.auth.team.favicon : null,
})

export default withRouter(connect(mapStateToProps, {})(App))
